import React, { useEffect, useState } from 'react';
import { translations } from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify/utils';
import '@aws-amplify/ui-react/styles.css';
import AuthAmplify from './components/AuthAmplify';
import AuthCustom from './components/AuthCustom';
import { Authenticator } from '@aws-amplify/ui-react';
import { useTranslation } from 'react-i18next';
import './i18n';
import { validateSocialProvider } from './utils/SocialProviderUtils';
import AppContent from './components/AppContent';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './pages/ErrorFallback';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthUser, getCurrentUser, signIn } from 'aws-amplify/auth';

const customProviderEnabled =
  import.meta.env.VITE_APP_CUSTOM_PROVIDER_ENABLED === 'true';
const socialProviderFromEnv = import.meta.env.VITE_APP_SOCIAL_PROVIDERS?.split(
  ','
).filter(validateSocialProvider);
const MISTRAL_ENABLED: boolean =
  import.meta.env.VITE_APP_ENABLE_MISTRAL === 'true';

const App: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const userState = useState<AuthUser | null>(null);
  const queryParams = new URLSearchParams(useLocation().search);
  const from_hp = queryParams.get('from') == 'hp'
  const [hidePage, setHidePage] = useState<boolean>(true);

  useEffect(() => {
    // set header title
    document.title = !MISTRAL_ENABLED
      ? t('app.name')
      : t('app.nameWithoutClaude');
    if (from_hp) {
      // HPからのアクセスの場合自動サインインを有効化する
      // サインインしているかを確認する
      getCurrentUser().then(user => {
        userState[1](user);
        setHidePage(false);
      }).catch(
        function () {
          setHidePage(true);
          signIn({ username: 'hp_user@dynaxt.co.jp', password: 't!EkN#n!5VJP?' }).then(() => {
            navigate('/bot/01HP4B6EP360ZC4F8MA8GQ4D1D?' + queryParams.toString());  // 画面遷移して
            navigate(0); // リロード
            setHidePage(false);
          })
        }
      )
    } else {
      setHidePage(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  I18n.putVocabularies(translations);
  I18n.setLanguage(i18n.language);

  return (<>
    {!hidePage &&
      <ErrorBoundary fallback={<ErrorFallback />}>
        {customProviderEnabled ? (
          <AuthCustom>
            <AppContent />
          </AuthCustom>
        ) : (
          <Authenticator.Provider>
            <AuthAmplify socialProviders={socialProviderFromEnv}>
              <AppContent />
            </AuthAmplify>
          </Authenticator.Provider>
        )}
      </ErrorBoundary>
    }</>
  );
};

export default App;